class LgReplacementProvider {
	constructor(popupMenu) {
		popupMenu.registerProvider('bpmn-replace', this)
	}

	getPopupMenuEntries(item) {
		return function (actions: object) {
			const entries = Object.entries(actions)
			const allowedEntries = entries.filter(([key, value]) => {
				if (
					key.match(
						/-(compensation|conditional|escalation|link|call|send|receive|manual|service)-/,
					)
				)
					return false
				if (key == 'replace-with-task') return false
				{
					// TO BE IMPLEMENTED
					if (key.match(/-(rule)-/)) return false
					if (key.match(/-(subprocess)$/)) return false
				}
				return true
			})

			const allowedActions = Object.fromEntries(allowedEntries)
			return allowedActions
		}
	}
}
;(LgReplacementProvider as any).$inject = ['popupMenu']

export const LgReplacementProviderModule = {
	__init__: ['lgReplacementProvider'],
	lgReplacementProvider: ['type', LgReplacementProvider],
}
